// 1. Khởi tạo Icons
lucide.createIcons();

// 2. Logic Counter (Chạy số khi cuộn đến)
const animateCounters = () => {
    const counters = document.querySelectorAll('.counter');
    const duration = 2000;
    const startTime = performance.now();
    
    const update = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        counters.forEach(counter => {
            const target = +counter.getAttribute('data-target');
            const start = +counter.getAttribute('data-start') || 0;
            counter.innerText = Math.round(start + (target - start) * progress).toLocaleString();
        });
        if (progress < 1) requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
};

const counterObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
        animateCounters();
        counterObserver.disconnect();
    }
}, { threshold: 0.5 });

const trustContainer = document.querySelector('.hero-trust-container');
if (trustContainer) counterObserver.observe(trustContainer);

// 3. Logic Auto-scroll cho "How It Works" (Chỉ Mobile)
const hiwContainer = document.querySelector('.hiw-bento');
let hiwInterval;

const startHiwScroll = () => {
    if (!hiwContainer) return;
    hiwInterval = setInterval(() => {
        if (window.innerWidth <= 768) {
            const firstCard = hiwContainer.querySelector('.hiw-card');
            const cardWidth = firstCard ? firstCard.offsetWidth + 15 : 0;
            const maxScroll = hiwContainer.scrollWidth - hiwContainer.clientWidth;

            if (hiwContainer.scrollLeft >= maxScroll - 5) {
                hiwContainer.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                hiwContainer.scrollBy({ left: cardWidth, behavior: 'smooth' });
            }
        }
    }, 3000);
};

if (hiwContainer) {
    hiwContainer.addEventListener('touchstart', () => clearInterval(hiwInterval));
    hiwContainer.addEventListener('touchend', startHiwScroll);
    startHiwScroll();
}

// 4. Logic Slider Testimonials
document.addEventListener('DOMContentLoaded', () => {
    const slider = document.getElementById('sliderContainer');
    const nextBtn = document.getElementById('testiNextBtn');
    const prevBtn = document.getElementById('testiPrevBtn');

    if (!slider || !nextBtn || !prevBtn) return;

    const getScrollAmount = () => {
        const firstCard = slider.querySelector('.testimonial-card-unique');
        return firstCard ? firstCard.offsetWidth + 20 : 0;
    };

    nextBtn.addEventListener('click', () => {
        const amount = getScrollAmount();
        const isAtEnd = slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth - 10);
        if (isAtEnd) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
            slider.scrollBy({ left: amount, behavior: 'smooth' });
        }
    });

    prevBtn.addEventListener('click', () => {
        const amount = getScrollAmount();
        if (slider.scrollLeft <= 10) {
            slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
        } else {
            slider.scrollBy({ left: -amount, behavior: 'smooth' });
        }
    });

    // Auto-play Testimonials
    setInterval(() => {
        if (!slider.matches(':hover')) {
            nextBtn.click();
        }
    }, 5000);
});